import React from 'react';
import {SvgIcon} from "@material-ui/core";
import {SvgIconProps} from "@material-ui/core/SvgIcon";

const GooglePlay = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      fontSize={'inherit'}
      viewBox="0 0 162 48">
      <g clipPath="url(#clip0)">
        <path
          d="M156 47.9916H6C2.64 47.9916 0 45.3525 0 41.9937V6.00626C0 2.64744 2.64 0.00836182 6 0.00836182H156C159.36 0.00836182 162 2.64744 162 6.00626V41.9937C162 45.3525 159.36 47.9916 156 47.9916Z"
          fill="black"
        />
        <path
          d="M156 0.968026C158.76 0.968026 161.04 3.24723 161.04 6.00626V41.9937C161.04 44.7527 158.76 47.0319 156 47.0319H6C3.24 47.0319 0.96 44.7527 0.96 41.9937V6.00626C0.96 3.24723 3.24 0.968026 6 0.968026H156ZM156 0.00836182H6C2.64 0.00836182 0 2.7674 0 6.00626V41.9937C0 45.3525 2.64 47.9916 6 47.9916H156C159.36 47.9916 162 45.3525 162 41.9937V6.00626C162 2.7674 159.36 0.00836182 156 0.00836182Z"
          fill="#A6A6A6"
        />
        <path
          d="M56.8807 12.2441C56.8807 13.2037 56.6407 14.0434 56.0407 14.6432C55.3207 15.363 54.4807 15.7229 53.4007 15.7229C52.3207 15.7229 51.4807 15.363 50.7607 14.6432C50.0407 13.9235 49.6807 13.0838 49.6807 12.0042C49.6807 10.9245 50.0407 10.0848 50.7607 9.36508C51.4807 8.64534 52.3207 8.28546 53.4007 8.28546C53.8807 8.28546 54.3607 8.40542 54.8407 8.64533C55.3207 8.88525 55.6807 9.12517 55.9207 9.48504L55.3207 10.0848C54.8407 9.48504 54.2407 9.24512 53.4007 9.24512C52.6807 9.24512 51.9607 9.48504 51.4807 10.0848C50.8807 10.5647 50.6407 11.2844 50.6407 12.1241C50.6407 12.9638 50.8807 13.6836 51.4807 14.1634C52.0807 14.6432 52.6807 15.0031 53.4007 15.0031C54.2407 15.0031 54.8407 14.7632 55.4407 14.1634C55.8007 13.8035 56.0407 13.3237 56.0407 12.7239H53.4007V11.7642H56.8807V12.2441ZM62.4007 9.24512H59.1607V11.5243H62.1607V12.364H59.1607V14.6432H62.4007V15.6029H58.2007V8.40542H62.4007V9.24512ZM66.3607 15.6029H65.4007V9.24512H63.3607V8.40542H68.4007V9.24512H66.3607V15.6029ZM71.8807 15.6029V8.40542H72.8407V15.6029H71.8807ZM76.9207 15.6029H75.9607V9.24512H73.9207V8.40542H78.8407V9.24512H76.8007V15.6029H76.9207ZM88.3207 14.6432C87.6007 15.363 86.7607 15.7229 85.6807 15.7229C84.6007 15.7229 83.7607 15.363 83.0407 14.6432C82.3207 13.9235 81.9607 13.0838 81.9607 12.0042C81.9607 10.9245 82.3207 10.0848 83.0407 9.36508C83.7607 8.64534 84.6007 8.28546 85.6807 8.28546C86.7607 8.28546 87.6007 8.64534 88.3207 9.36508C89.0407 10.0848 89.4007 10.9245 89.4007 12.0042C89.4007 13.0838 89.0407 13.9235 88.3207 14.6432ZM83.7607 14.0434C84.2407 14.5233 84.9607 14.8831 85.6807 14.8831C86.4007 14.8831 87.1207 14.6432 87.6007 14.0434C88.0807 13.5636 88.4407 12.8439 88.4407 12.0042C88.4407 11.1645 88.2007 10.4447 87.6007 9.96487C87.1207 9.48504 86.4007 9.12517 85.6807 9.12517C84.9607 9.12517 84.2407 9.36508 83.7607 9.96487C83.2807 10.4447 82.9207 11.1645 82.9207 12.0042C82.9207 12.8439 83.1607 13.5636 83.7607 14.0434ZM90.7207 15.6029V8.40542H91.8007L95.2807 14.0434V8.40542H96.2407V15.6029H95.2807L91.5607 9.72496V15.6029H90.7207Z"
          fill="white"
        />
        <path
          d="M81.7194 26.1593C78.8394 26.1593 76.5594 28.3185 76.5594 31.3175C76.5594 34.1965 78.8394 36.4757 81.7194 36.4757C84.5994 36.4757 86.8794 34.3164 86.8794 31.3175C86.8794 28.1986 84.5994 26.1593 81.7194 26.1593ZM81.7194 34.3164C80.1594 34.3164 78.8394 32.9969 78.8394 31.1975C78.8394 29.3981 80.1594 28.0786 81.7194 28.0786C83.2794 28.0786 84.5994 29.2782 84.5994 31.1975C84.5994 32.9969 83.2794 34.3164 81.7194 34.3164ZM70.5594 26.1593C67.6794 26.1593 65.3994 28.3185 65.3994 31.3175C65.3994 34.1965 67.6794 36.4757 70.5594 36.4757C73.4394 36.4757 75.7194 34.3164 75.7194 31.3175C75.7194 28.1986 73.4394 26.1593 70.5594 26.1593ZM70.5594 34.3164C68.9994 34.3164 67.6794 32.9969 67.6794 31.1975C67.6794 29.3981 68.9994 28.0786 70.5594 28.0786C72.1194 28.0786 73.4394 29.2782 73.4394 31.1975C73.4394 32.9969 72.1194 34.3164 70.5594 34.3164ZM57.2393 27.7187V29.878H62.3994C62.2794 31.0775 61.7994 32.0372 61.1994 32.637C60.4794 33.3567 59.2794 34.1965 57.2393 34.1965C53.9993 34.1965 51.5993 31.6773 51.5993 28.4385C51.5993 25.1996 54.1193 22.6805 57.2393 22.6805C58.9194 22.6805 60.2394 23.4002 61.1994 24.2399L62.7594 22.6805C61.4394 21.4809 59.7593 20.5212 57.3593 20.5212C53.0393 20.5212 49.3193 24.12 49.3193 28.4385C49.3193 32.757 53.0393 36.3557 57.3593 36.3557C59.7593 36.3557 61.4394 35.636 62.8794 34.0765C64.3194 32.637 64.7994 30.5977 64.7994 29.0383C64.7994 28.5584 64.7994 28.0786 64.6794 27.7187H57.2393ZM111.719 29.3981C111.239 28.1986 110.039 26.1593 107.399 26.1593C104.759 26.1593 102.599 28.1986 102.599 31.3175C102.599 34.1965 104.759 36.4757 107.639 36.4757C109.919 36.4757 111.359 35.0362 111.839 34.1965L110.159 32.9969C109.559 33.8366 108.839 34.4364 107.639 34.4364C106.439 34.4364 105.719 33.9565 105.119 32.8769L111.959 29.9979L111.719 29.3981ZM104.759 31.0775C104.759 29.1582 106.319 28.0786 107.399 28.0786C108.239 28.0786 109.079 28.5584 109.319 29.1582L104.759 31.0775ZM99.1194 35.9958H101.399V21.0011H99.1194V35.9958ZM95.5194 27.2389C94.9194 26.6391 93.9594 26.0393 92.7594 26.0393C90.2394 26.0393 87.8394 28.3185 87.8394 31.1975C87.8394 34.0765 90.1194 36.2357 92.7594 36.2357C93.9594 36.2357 94.9194 35.636 95.3994 35.0362H95.5194V35.7559C95.5194 37.6752 94.4394 38.7549 92.7594 38.7549C91.4394 38.7549 90.4794 37.7952 90.2394 36.9555L88.3194 37.7952C88.9194 39.1147 90.3594 40.7941 92.8794 40.7941C95.5194 40.7941 97.6794 39.2347 97.6794 35.516V26.3992H95.5194V27.2389ZM92.8794 34.3164C91.3194 34.3164 89.9994 32.9969 89.9994 31.1975C89.9994 29.3981 91.3194 28.0786 92.8794 28.0786C94.4394 28.0786 95.6394 29.3981 95.6394 31.1975C95.6394 32.9969 94.4394 34.3164 92.8794 34.3164ZM122.159 21.0011H116.759V35.9958H119.039V30.3578H122.159C124.679 30.3578 127.079 28.5584 127.079 25.6794C127.079 22.8004 124.679 21.0011 122.159 21.0011ZM122.279 28.1986H119.039V23.0404H122.279C123.959 23.0404 124.919 24.4799 124.919 25.5595C124.799 26.879 123.839 28.1986 122.279 28.1986ZM136.079 26.0393C134.399 26.0393 132.719 26.7591 132.119 28.3185L134.159 29.1582C134.639 28.3185 135.359 28.0786 136.199 28.0786C137.399 28.0786 138.479 28.7983 138.599 29.9979V30.1179C138.239 29.878 137.279 29.5181 136.319 29.5181C134.159 29.5181 131.999 30.7177 131.999 32.8769C131.999 34.9162 133.799 36.2357 135.719 36.2357C137.279 36.2357 137.999 35.516 138.599 34.7962H138.719V35.9958H140.879V30.2378C140.639 27.5988 138.599 26.0393 136.079 26.0393ZM135.839 34.3164C135.119 34.3164 134.039 33.9565 134.039 32.9969C134.039 31.7973 135.359 31.4374 136.439 31.4374C137.399 31.4374 137.879 31.6773 138.479 31.9173C138.239 33.3567 137.039 34.3164 135.839 34.3164ZM148.439 26.3992L145.919 32.8769H145.799L143.159 26.3992H140.759L144.719 35.516L142.439 40.5542H144.719L150.839 26.3992H148.439ZM128.279 35.9958H130.559V21.0011H128.279V35.9958Z"
          fill="white"
        />
        <path
          d="M12.48 9.00519C12.12 9.36506 12 9.96485 12 10.6846V37.1953C12 37.9151 12.24 38.5149 12.6 38.8747L12.72 38.9947L27.6 24.1199V23.88L12.48 9.00519Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M32.4005 29.1582L27.4805 24.24V23.8801L32.4005 18.9618L32.5205 19.0817L38.4005 22.4406C40.0805 23.4002 40.0805 24.9597 38.4005 25.9194L32.4005 29.1582Z"
          fill="url(#paint1_linear)"
        />
        <path
          d="M32.5195 29.0382L27.4795 24L12.4795 38.9948C13.0795 39.5946 13.9195 39.5946 14.9995 39.1147L32.5195 29.0382Z"
          fill="url(#paint2_linear)"
        />
        <path
          d="M32.5195 18.9618L14.9995 9.00523C13.9195 8.40544 13.0795 8.5254 12.4795 9.12519L27.4795 24L32.5195 18.9618Z"
          fill="url(#paint3_linear)"
        />
        <path
          opacity="0.2"
          d="M32.3995 28.9183L14.9995 38.7549C14.0395 39.3547 13.1995 39.2347 12.5995 38.7549L12.4795 38.8748L12.5995 38.9948C13.1995 39.4746 14.0395 39.5946 14.9995 38.9948L32.3995 28.9183Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M12.48 38.7548C12.12 38.395 12 37.7952 12 37.0754V37.1954C12 37.9151 12.24 38.5149 12.6 38.8748V38.7548H12.48ZM38.4 25.5595L32.4 28.9183L32.52 29.0382L38.4 25.6794C39.24 25.1996 39.6 24.5998 39.6 24C39.6 24.5998 39.12 25.0796 38.4 25.5595Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M15 9.12521L38.4 22.4406C39.12 22.9204 39.6 23.4002 39.6 24C39.6 23.4002 39.24 22.8004 38.4 22.3206L15 9.00525C13.32 8.04559 12 8.76534 12 10.6847V10.8046C12 9.00525 13.32 8.16555 15 9.12521Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="26.16"
          y1="10.4567"
          x2="6.02744"
          y2="30.5951"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#00A0FF"/>
          <stop
            offset="0.007"
            stopColor="#00A1FF"
          />
          <stop
            offset="0.26"
            stopColor="#00BEFF"
          />
          <stop
            offset="0.512"
            stopColor="#00D2FF"
          />
          <stop
            offset="0.76"
            stopColor="#00DFFF"
          />
          <stop
            offset="1"
            stopColor="#00E3FF"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="40.6013"
          y1="24.0012"
          x2="11.5648"
          y2="24.0012"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFE000"/>
          <stop
            offset="0.409"
            stopColor="#FFBD00"
          />
          <stop
            offset="0.775"
            stopColor="#FFA500"
          />
          <stop
            offset="1"
            stopColor="#FF9C00"
          />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="29.7919"
          y1="26.7542"
          x2="2.4918"
          y2="54.0638"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF3A44"/>
          <stop
            offset="1"
            stopColor="#C31162"
          />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="8.75589"
          y1="0.219507"
          x2="20.9472"
          y2="12.4151"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#32A071"/>
          <stop
            offset="0.069"
            stopColor="#2DA771"
          />
          <stop
            offset="0.476"
            stopColor="#15CF74"
          />
          <stop
            offset="0.801"
            stopColor="#06E775"
          />
          <stop
            offset="1"
            stopColor="#00F076"
          />
        </linearGradient>
        <clipPath id="clip0">
          <rect
            width="162"
            height="48"
            fill="white"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default GooglePlay;